export default "__VITE_ASSET__BhpYF6yk__"